import styled from "styled-components";

export const EmptyWrapper = styled.div`
    background-color: white;
    border-radius: 8px;
    padding: 40px 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;

    @media screen and (max-width: 768px) {
        padding: 24px 16px;
        margin-top: 16px;
        border-radius: 6px;
    }

    @media screen and (max-width: 480px) {
        padding: 20px 12px;
        margin-top: 12px;
        border-radius: 4px;
    }
`;

export const InfoItem = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;

    @media screen and (max-width: 768px) {
        margin-bottom: 12px;
    }

    @media screen and (max-width: 480px) {
        margin-bottom: 10px;
    }
`;

export const CustomerCashOnDeliveryPageContainer = styled.div`
    width: 100%;
    margin-top: -50px;

    @media screen and (max-width: 768px) {
        margin-top: 50px;
    }
`;
